// extracted by mini-css-extract-plugin
export default {"backButton":"backButton_backButton__1mzq+"};